import { Component } from '@angular/core';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { ListItemRendererComponent } from 'gung-list';
import { SchedulerOverview } from '../../models/scheduler';
import { DateUtilService } from 'gung-common';

@Component({
  selector: 'lib-schedulers-list',
  templateUrl: './schedulers-list.component.html',
  styleUrl: './schedulers-list.component.scss'
})
export class SchedulersListComponent extends ListItemRendererComponent<SchedulerOverview[]> {
  lastException: { jobName: string; lastExceptionDate: Date; lastExceptionTrace: string };

  constructor(public dateUtilService: DateUtilService, protected modalService: NgbModal) {
    super();
  }

  showLastExceptionTrace(scheduler: SchedulerOverview, content) {
    this.lastException = {
      jobName: scheduler.jobName,
      lastExceptionDate: scheduler.endTime,
      lastExceptionTrace: scheduler.exception
    };

    this.modalService
      .open(content, { ariaLabelledBy: 'modal-basic-title', size: 'xl', windowClass: 'modal-xl-custom' })
      .result.finally(() => {
        this.lastException = undefined;
      });
  }
}
